import api from "./api";
import { toast } from "sonner";

const fmtMB = (b) => `${(b / 1024 / 1024).toFixed(b > 10 * 1024 * 1024 ? 0 : 1)} MB`;

function Bar({ pct }) {
  return (
    <div className="mt-1.5 h-1.5 w-full rounded-full bg-white/10 overflow-hidden" data-testid="upload-toast-bar">
      <div className="h-full nexus-gradient transition-[width] duration-150" style={{ width: `${pct}%` }} />
    </div>
  );
}

/**
 * Upload a single file to /api/uploads with a live percentage toast.
 * Resolves with the API response data ({ url, ... }). Throws on failure (after showing an error toast).
 */
export async function uploadFile(file, { label } = {}) {
  const name = label || file.name || "file";
  const id = toast.loading(`Uploading ${name} · 0%`, { description: <Bar pct={0} />, duration: Infinity });
  const fd = new FormData();
  fd.append("file", file);
  try {
    const { data } = await api.post("/uploads", fd, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => {
        const pct = e.total ? Math.min(99, Math.round((e.loaded * 100) / e.total)) : 0;
        toast.loading(`Uploading ${name} · ${pct}%`, {
          id,
          description: <div><Bar pct={pct} /><div className="text-[11px] text-zinc-500 mt-1">{fmtMB(e.loaded)} of {fmtMB(e.total || file.size)}</div></div>,
          duration: Infinity,
        });
      },
    });
    toast.success(`${name} uploaded`, { id, description: undefined, duration: 2500 });
    return data;
  } catch (err) {
    const detail = err.response?.data?.detail;
    toast.error(typeof detail === "string" ? detail : `Upload failed — ${name}`, { id, description: undefined, duration: 5000 });
    throw err;
  }
}
